import React from 'react';
import { Button as ChakraButton } from '@chakra-ui/react';

const Button = ({
  children = null,
  type = `button`,
  variant = null,
  isActive = false,
  isDisabled = false,
  onClick = () => {},
  onFocus = () => {},
  onBlur = () => {},
  ...props
}) => {
  return (
    <ChakraButton
      variant={variant}
      type={type}
      isActive={!isDisabled && isActive}
      isDisabled={isDisabled}
      onClick={onClick}
      onFocus={onFocus}
      onBlur={onBlur}
      {...props}>
      {children}
    </ChakraButton>
  );
};

export default Button;
